import React from 'react';
import { BrowserRouter } from 'react-router';
import { useMaintenanceMode } from '@askporter/api-client';
import MaintenancePage from '../../pages/MaintenancePage';

interface Props {
  children: React.ReactNode[] | React.ReactNode;
}

/**
 * The MaintenanceModeDetector component aims to capture ALL Grieg 503s for requests made using Axios. The main known
 * exclusion is calls to the static/tenant made in the ConfigProvider, these fallback to a static maintenance page and
 * are triggered by the ConfigProvider.
 */
const MaintenanceModeDetector: React.FC<React.PropsWithChildren<Props>> = ({ children }: Props) => {
  const isMaintenanceMode = useMaintenanceMode();

  return isMaintenanceMode ? (
    <BrowserRouter>
      <MaintenancePage />
    </BrowserRouter>
  ) : (
    <>{children}</>
  );
};

export default MaintenanceModeDetector;
